import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/user/login'
  },
  // User End Routes
  {
    path: '/user',
    redirect: '/user/login',
    component: () => import('@/views/user/Layout.vue'), // Optional: if you have a layout
    children: [
      {
        path: 'login',
        name: 'UserLogin',
        component: () => import('@/views/user/Login.vue')
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/views/user/ForgotPassword.vue')
      },
      {
        path: 'home',
        name: 'UserHome',
        component: () => import('@/views/user/Home.vue'),
        meta: { requiresUserAuth: true }
      },
      {
        path: 'product/:id',
        name: 'ProductDetail',
        component: () => import('@/views/user/ProductDetail.vue'),
        meta: { requiresUserAuth: true }
      }
    ]
  },
  // Sales End Routes
  {
    path: '/sales',
    redirect: '/sales/login',
    component: () => import('@/views/sales/Layout.vue'), // Optional
    children: [
      {
        path: 'login',
        name: 'SalesLogin',
        component: () => import('@/views/sales/Login.vue')
      },
      {
        path: 'dashboard',
        name: 'SalesDashboard',
        component: () => import('@/views/sales/SalesHome.vue'),
        meta: { requiresSalesAuth: true }
      },
      {
        path: 'collection-registration',
        name: 'CollectionRegistration',
        component: () => import('@/views/sales/CollectionRegistration.vue'),
        meta: { requiresSalesAuth: true }
      },
      {
        path: 'user-detail/:id',
        name: 'SalesUserDetail',
        component: () => import('@/views/sales/UserDetail.vue'),
        meta: { requiresSalesAuth: true }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Route Guard
router.beforeEach((to, from, next) => {
  // Check User Auth
  if (to.matched.some(record => record.meta.requiresUserAuth)) {
    if (!store.state.user.token) {
      next({
        path: '/user/login',
        query: { redirect: to.fullPath }
      })
      return
    }
  }

  // Check Sales Auth
  if (to.matched.some(record => record.meta.requiresSalesAuth)) {
    if (!store.state.sales.token) {
      next({
        path: '/sales/login',
        query: { redirect: to.fullPath }
      })
      return
    }
  }

  next()
})

export default router
